module.exports = __webpack_public_path__ + "static/media/wcb-3.f21034bc.png";